<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :tree-config="treeConfig"
      :height="tableHeight"
      size="small"
      :seq-config="seqConfig"
      cell-class-name="align-top"
      resizable
      show-footer
      :footer-method="footerMethod"
      ref="inventoryTable"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg',
          ]"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 60px; height: 60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:displayName="{ row }">
        <span>SKU:</span><span style="color: #303133">{{ row.amzSkuNo }}</span>
        <br />
        <span>{{ row.brandName }}</span>
        <br />
        <span>{{ row.goodsName }}</span>
        <br />
        <span>{{ row.goodsNameEn }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: () => {},
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      treeConfig: {
        transform: true,
        rowField: 'amzSkuCode',
        parentField: 'parentId',
        lazy: true,
        hasChild: 'hasChild',
        loadMethod: this.loadChildDate,
      },
      seqConfig: {
        seqMethod: this.seqMethod
      },
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    footerData() {
      if (!this.tableData) return []
      if (this.tableData.length <= 0) return []
      const sumData = this.tableData[0].sumData

      let footerRow = [
        this.$l('INDEX.total') || '合计',
        '',
        '',
        '',
        sumData.sumSkuInvQty,
        sumData.sumSkuInvAmount,
        sumData.sumFtyInvQty,
        sumData.sumFtyInvAmount,
        sumData.sumFbaTotalQty,
        sumData.sumFbaTotalAmount,
        sumData.sumFbaAvailableQty,
        sumData.sumFbaPaddingMoveQty,
        sumData.sumFbaFreezesMoveQty,
        sumData.sumFbaPaddingShipmentQty,
        sumData.sumFbaNotForSaleQty,
        sumData.sumFbaInboundWorkingQty,
        sumData.sumFbaInboundShippedQty,
        sumData.sumFbaInboundReceivingQty,
      ]
      return [footerRow]
    },
  },
  methods: {
    footerMethod() {
      return this.footerData
    },
    async loadChildDate({ row }) {
      const { amzSkuCode } = row || {}
      if (!amzSkuCode) return []

      const res = await this.$api.ecomecomAmzSkuInvExpandDetailApi({
        amzSkuCode:amzSkuCode
      }).catch(() => null)
      if (!res) return []

      const data = res.body.data || []
      return data.map((item) => {
        return {
          goodsName: item['storeName'],
          fbaTotalQty: item['fbaTotal'],
          fbaTotalAmount: item['fbaAmount'],
          fbaAvailableQty: item['available'],
          fbaPendingRemoveQty: item['pendingRemovalQuantity'],
          fbaInboundQty: item['inboundQuantity'],
          fbaInboundWorkingQty: item['inboundWorking'],
          fbaInboundRecvQty: item['inboundReceived'],
          fbaReservedQty: item['reservedQuantity'],
          fbaUnfulfillableQty: item['unfulfillableQuantity'],
          parentId: amzSkuCode,
          rowId: row['rowId'],
          hasChild: false,
        }
      })
    },
    seqMethod({row, rowIndex}) {
      const seq = (this.tablePage.curPage - 1) * this.tablePage.pageSize
      if(!row['hasChild']) {
         return row['rowId'] + '.' + (rowIndex + 1)
      }
      row['rowId'] = seq + rowIndex + 1
      return row['rowId']
    },
  },
}
</script>
